import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Core components
import Tooltip from 'components/core/Tooltip';
// Custom
import { cpmParkingCategoryDataShape } from 'constants/PropTypesShapes';
import ParkingCategoryIcon from './ParkingCategoryIcon';
import ParkingCategoryTitle from './ParkingCategoryTitle';

const ParkingCategoryIdIntegIcon = ({ withTooltip, parkingCategory }) => {
  if (parkingCategory) {
    return (
      <div className="d-flex mr-2">
        {withTooltip ? (
          <Tooltip content={<ParkingCategoryTitle parkingCategory={parkingCategory} />}>
            <ParkingCategoryIcon parkingCategory={parkingCategory} />
          </Tooltip>
        ) : (
          <ParkingCategoryIcon parkingCategory={parkingCategory} />
        )}
      </div>
    );
  }
  return null;
};

ParkingCategoryIdIntegIcon.propTypes = {
  withTooltip: PropTypes.bool,
  parkingCategoryId: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  parkingCategory: cpmParkingCategoryDataShape,
};

ParkingCategoryIdIntegIcon.defaultProps = {
  withTooltip: false,
  parkingCategoryId: null,
  parkingCategory: null, // May be null if user has not permission to load parking categories
};

const mapStateToProps = (state, ownProps) => ({
  parkingCategory: _find(state.cpmCarparkParkingCategory.list.elements, ['id', ownProps.parkingCategoryId]),
});

module.exports = connect(
  mapStateToProps,
)(ParkingCategoryIdIntegIcon);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkingCategories/ParkingCategoryIdIntegIcon.js